// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"597fa706","455":"262b3279"}[chunkId] + ".chunk.js";
};